import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27bed403"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-footer" }
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0-.25h24v24H0z",
    fill: "none"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { goTo } from '@/router'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFooter',
  props: {
  langs: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_base_locale_select = _resolveComponent("base-locale-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.langs.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_locale_select)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "icon house",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goTo)({ name: 'Home' })))
      }, _hoisted_5),
      _createElementVNode("div", {
        class: "icon start",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goTo)({ name: 'Play' })))
      }, _hoisted_7),
      _createElementVNode("div", {
        class: "icon question-mark",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goTo)({ name: 'Help' })))
      }, "?")
    ])
  ]))
}
}

})